const publishNewRelicPageAction = ({ actionName = '', actionObject = null }) => {
  if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    LIFE_CYCLE_EVENT_BUS.trigger('cart.cartPageAction', { actionName, actionObject });
  }
};

export const paypalSmartButtonClickNewRelic = (ffm, fromPage, hasSavedPaypal, isUpdatePaypal = false, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonClick',
    actionObject: {
      fulfillment: ffm,
      hasSavedPaypal,
      isUpdatePaypal,
      page: fromPage,
      payInFour
    }
  });
};

export const paypalSmartButtonSuccessNewRelic = (fromPage, cartId, payInFour, paypalData) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonSuccess',
    actionObject: {
      cartId,
      page: fromPage,
      payInFour,
      paypalData
    }
  });
};

export const paypalSmartButtonCancelNewRelic = (fromPage, cartId, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonCancel',
    actionObject: {
      cartId,
      page: fromPage,
      payInFour
    }
  });
};

export const paypalSmartButtonErrorNewRelic = (error, fromPage, payInFour, cartId) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonError',
    actionObject: {
      cartId,
      error: JSON.stringify(error),
      page: fromPage,
      payInFour
    }
  });
};

export const paypalSmartButtonAddToCartFailNewRelic = (fromPage, payInFour, errorObj) => {
  const { description, errorCode } = errorObj || {};
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonAddToCartFail',
    actionObject: {
      error: description || 'Unknown error',
      errorCode: errorCode || '',
      page: fromPage,
      payInFour
    }
  });
};

export const paypalSmartButtonInitFailNewRelic = (errorCode, description, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalSmartButtonInitFail',
    actionObject: {
      error: description || 'Unknown error',
      errorCode: errorCode || '',
      payInFour
    }
  });
};

export const savedPaypalButtonClickNewRelic = (isAuthUser, isValidCart, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'savedPaypalButtonClick',
    actionObject: {
      isAuthUser,
      isValidCart,
      payInFour
    }
  });
};

export const paypalMessageClickNewRelic = (fromPage) => {
  publishNewRelicPageAction({
    actionName: 'paypalMessageClick',
    actionObject: {
      page: fromPage,
    }
  });
};

export const paypalMissingData = (fromPage, missingProps, payInFour) => {
  publishNewRelicPageAction({
    actionName: 'paypalMissingData',
    actionObject: {
      missingProps,
      page: fromPage,
      payInFour,
    }
  });
};